import { useTranslation } from '@gimlite/common';
import { observer } from 'mobx-react-lite';
import { Button } from '../components/button/button.component';
import { Col } from '../components/col/col.component';
import { Row } from '../components/row/row.component';
import { Write } from '../components/write/write.component';
import { useStoreUIV1 } from '../hooks/useStore.hook';

export const Page498 = observer(() => {
  const { SSOStore } = useStoreUIV1();
  const { t } = useTranslation();

  return (
    <Row
      config={{
        height: 'full',
        horizontal: 'center',
        vertical: 'center',
      }}
    >
      <Col
        config={{
          height: 'initial',
          horizontal: 'center',
          vertical: 'center',
          gap: 16,
        }}
      >
        <Col
          config={{
            horizontal: 'center',
            vertical: 'center',
            height: 'initial',
            gap: 8,
          }}
        >
          <Write
            data={{ item: t('watermelon-498_TITLE') }}
            config={{ mode: 'title-medium' }}
          />
          <Write
            data={{ item: t('watermelon-498_DESCRIPTION') }}
            config={{ mode: 'value-small' }}
          />
        </Col>

        <Button
          config={{
            mode: 'fill',
            size: 'medium',
            text: t('watermelon-logIn'),
          }}
          handleEvent={{
            click: () => {
              SSOStore.instance?.login();
            },
          }}
        ></Button>
      </Col>
    </Row>
  );
});
